import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Edit,
} from "@mui/icons-material";
import {
    Button,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    TextField,
    MenuItem,
    Alert,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { DeleteModal, PopupModal } from "../../Components/Modal/Modals";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    DeleteBusiness,
    getAllBusiness,
    resetBusiness,
    searchBusiness,
} from "../../Redux/BusSlice/BusSlice";
import BusinessForm from "./BusinessForm";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const AllBusiness = () => {
    const dispatch = useDispatch();
    //get the data from reducer
    const { business, isBusLodaing } = useSelector((state) => state.business);

    const ALL_BUSINESS = business ? business?.data?.data : [];
    const PanelsPagination = business ? business?.data : [];

    // Paginate Data
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    // Filter By Fields Variables
    const [title, setTitle] = useState("");
    const [initial, setInitial] = useState("");
    const [is_active, setActive] = useState("");

    const searchObj = {
        title,
        initial,
        is_active,
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                searchBusiness({
                    ...searchObj,
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(resetBusiness());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);

        handelFilterAction(searchObj);
    };

    const handelFilterAction = async (search_obj = null) => {
        await dispatch(
            searchBusiness({ ...search_obj, paginate: rowsPerPage })
        );
        await dispatch(resetBusiness());
    };

    const handelResetData = () => {
        setTitle("");
        setInitial("");
        setActive("");

        handelFilterAction();
    };

    function inputKeyUp(e) {
        e.which = e.which || e.keyCode;
        if (e.which === 13) {
            //Key code of Enter
            handelFilterAction(searchObj);
        }
    }

    //state for delete modal
    const [data, setData] = useState({});

    //delete row
    const [open, setOpen] = useState(false);
    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };

    //edit row
    const [edit, setEdit] = useState(false);
    const handelOpenEditRow = (data) => {
        setData(data);
        setEdit(true);
    };
    const handelCloseEditRow = () => {
        setData({});
        setEdit(false);
    };

    // handleDelete
    const DeleteRow = async () => {
        handleClose();
        await dispatch(DeleteBusiness({ business_id: data.id }));
        await dispatch(getAllBusiness());
        await dispatch(resetBusiness());
    };

    useEffect(() => {
        const getAll = async () => {
            await dispatch(getAllBusiness());
            await dispatch(resetBusiness());
        };
        getAll();
    }, [dispatch]);

    if (!business) {
        return <LoadingAnimation />;
    }
    return (
        <>
            {/* <button onClick={(e) => callSearchAction()}>search</button> */}

            {isBusLodaing && <LoadingAnimation />}
            {!isBusLodaing && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell style={{ padding: "5px" }}>
                                    Filter By :
                                </TableCell>
                                <TableCell
                                    style={{ padding: "5px" }}
                                    width={500}
                                >
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="title"
                                            name="title"
                                            label="Title"
                                            value={title}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setTitle(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="initial"
                                            name="initial"
                                            label="Initial"
                                            value={initial}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setInitial(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">
                                                Active
                                            </InputLabel>
                                            <Select
                                                id="is_active"
                                                name="is_active"
                                                label="Active"
                                                value={is_active}
                                                onChange={(e) =>
                                                    setActive(e.target.value)
                                                }
                                            >
                                                <MenuItem value="2">
                                                    Inactive
                                                </MenuItem>
                                                <MenuItem value="1">
                                                    Active
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </TableCell>
                                <TableCell
                                    style={{ padding: "5px" }}
                                    align="center"
                                >
                                    <Grid container coulmns={12}>
                                        <Button
                                            style={{ marginBottom: "5px" }}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) =>
                                                handelFilterAction(searchObj)
                                            }
                                        >
                                            <FilterAltIcon></FilterAltIcon>
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => handelResetData()}
                                        >
                                            <RestartAltIcon></RestartAltIcon>
                                        </Button>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHeadStyled>
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>initial</TableCell>
                                <TableCell align="center">Active</TableCell>
                                <TableCell align="center">ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {ALL_BUSINESS?.map((key, index) => (
                                <TableRowStyled key={key?.id}>
                                    <TableCellStyle>
                                        {rowsPerPage * page + index + 1}
                                    </TableCellStyle>
                                    <TableCellStyle>{key.title}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.initial}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        {key.is_active !== 0 ? (
                                            <CheckCircleOutline color="primary" />
                                        ) : (
                                            <DoDisturbOn />
                                        )}
                                    </TableCellStyle>

                                    <TableCellStyle align="center">
                                        <IconButton
                                            onClick={() => {
                                                handelOpenEditRow(key);
                                            }}
                                        >
                                            <Edit color="primary" />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => handleOpen(key)}
                                        >
                                            <ProgressStyled>
                                                <Delete color="error" />
                                            </ProgressStyled>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                        {PanelsPagination.total >= 20 && (
                            <TablePagination
                                rowsPerPageOptions={[
                                    PanelsPagination.total,
                                    PanelsPagination.total * 4,
                                    PanelsPagination.total * 6,
                                    { label: "All", value: -1 },
                                ]}
                                colSpan={12}
                                count={PanelsPagination.total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </Table>
                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.title}
                        onClick={DeleteRow}
                        loading={isBusLodaing}
                    />
                    {/* EDIT MODAL  */}
                    <PopupModal open={edit} close={handelCloseEditRow}>
                        <BusinessForm data={data} />
                    </PopupModal>
                    {PanelsPagination.total < 1 && (
                        <Alert icon={false} severity="error" style={{textAlign:"center"}} >
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )}
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllBusiness;
